var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVirginIslands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:54093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.418C24.8366 32.418 32 25.2545 32 16.418C32 7.58141 24.8366 0.417969 16 0.417969C7.16344 0.417969 0 7.58141 0 16.418C0 25.2545 7.16344 32.418 16 32.418Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7182 11.5957C18.7182 10.0949 17.5016 8.87831 16.0008 8.87831C14.5 8.87831 13.2834 10.0949 13.2834 11.5957H7.30518C7.30518 13.0732 8.5923 14.2712 10.0699 14.2712H9.98086C9.98086 15.7489 11.1786 16.9469 12.6564 16.9469C12.6564 18.2552 13.5961 19.3423 14.837 19.5747L14.8301 19.5903H17.1716L17.1647 19.5747C18.4057 19.3422 19.3452 18.2551 19.3452 16.9469C20.823 16.9469 22.0208 15.7489 22.0208 14.2712H21.9317C23.4092 14.2712 24.6964 13.0732 24.6964 11.5957H18.7182Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8067 19.313L13.1218 23.117C14.0108 23.4783 14.9825 23.6792 16.0013 23.6792C17.0201 23.6792 17.9918 23.4784 18.8807 23.117L17.1959 19.313H14.8067Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.522 12.9326V17.6133C12.522 20.2756 16.0002 21.0915 16.0002 21.0915C16.0002 21.0915 19.4785 20.2756 19.4785 17.6133V12.9326H12.522Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.88016 16.5308L5.76135 21.7923L7.62298 16.5308H9.04373L6.3296 23.4873H5.19304L2.45947 16.5308H3.88016Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7388 23.4873V16.5308H27.0908V23.4873H25.7388Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9126 14.4435V20.1157C14.3908 20.4676 14.9053 20.7097 15.3039 20.8647V14.4435H13.9126Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0861 14.4435V20.1157C17.6079 20.4676 17.0934 20.7097 16.6948 20.8647V14.4435H18.0861Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.522 12.9324H19.4785V15.1397H12.522V12.9324Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:54093"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.417969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirginIslands);
export default __webpack_public_path__ + "static/media/virgin-islands.c8fe3ed1.svg";
export { ForwardRef as ReactComponent };